import React from "react";
import { Space, Spin, Typography } from "antd";

const LoaderRelative = ({ loading = false, tips = "" }) => {
  const { Title } = Typography;

  return (
    loading && (
      <div className="loader-over-lay-relative">
        <Space size="middle" direction="vertical" align="center">
          <Spin spinning={loading} size="large" />
          {tips.length > 0 && <Title level={3}>{tips}</Title>}
        </Space>
      </div>
    )
  );
};

export default LoaderRelative;
